import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../../components';
import StackedPercentageAreaChart from '../../../charts/StackedPercentageAreaChart';
import { dataToStackChartData } from '../../../../services/data/charts/dataToStackChartData';
import { useGetAppAdminOsVersionPerDayQuery } from '../../../../api/appAdminApiSlice';
import Block from '../../../Block';

const DevicePerOsVersionEvolution = ({appId, ...props}) => {
  const { t } = useTranslation();
  const {data = [], isSuccess, isError, refetch} = useGetAppAdminOsVersionPerDayQuery(appId)
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const appData = dataToStackChartData("major_os_version")(data)

  return (
    <Block title={t('version.device_per_os_version_evolution')} {...props}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <StackedPercentageAreaChart  data={appData}  legendOptions={{show: false}} />
      </Loader>
    </Block>
  )
}

export default DevicePerOsVersionEvolution
